import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import { Tooltip } from '@mui/material';
import ButtonAction from './ButtonAction';
import {SearchAdvanceIcon, SearchIcon} from './IconButtons';

const SearchFilterBtn = ({id="btn_sfb_search", fnclick, finalArray }) => {
    const { t } = useTranslation();
    const [numberSearch, setNumberSearch] = useState(0);
    useEffect(() => {
        setNumberSearch(finalArray.length);
    }, [finalArray]);


    return (
        <div className='relative-container-dot'>
            <ButtonAction
                id={id}
                name='search'
                className='btn-icon-search'
                Icon={SearchAdvanceIcon}
                onClick={(e)=>{fnclick(e)}}
                splitName={false}
            />
            <Tooltip title={t('has_searches').toUpperCase()} placement='top' disableInteractive>
                <span className='notification-wrapper'>
                    {numberSearch > 0 && <div className='notification-dot'>{numberSearch}</div>}
                </span>
            </Tooltip>
        </div>
    );
};

export default SearchFilterBtn;
